import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/boundingBox/actions';

class BboxImgRes extends React.Component {
    
    componentWillMount(){
        this.props.initBboxDataLoading();
    }

    componentDidMount(){
        const { bb,match } = this.props;
        this.props.grabBboxData(match.params.taskId)
    }

    render(){
        const { bb,match } = this.props;
        if (!match.params.taskId ) {
            return (
                <div className="container">
                  <div className="row">
                        <br />
                   </div>  
                   <div className="row">
                        <h3>Bounding Box Image Result</h3>
                    </div>
                    <div className="row">
                        <div className="alert alert-danger" role="alert">
                          ERROR! Missing Parameters!
                        </div>      
                    </div>    
                </div>
            )   
        }

        if (bb.imgDataLoading){
            return (
                <div className='container'>
                    <div className="row">
                        <br />
                    </div> 
                    <div className="row">
                        <h3>Bounding Box Image Result</h3>
                    </div>
                    <div className='row'>
                       <div className="alert alert-danger" role="alert">
                          Loading... please wait.
                        </div> 
                    </div>    
                </div>    
            )
        }
        if (!bb.imgData){
            return (
                <div className='container'>
                    <div className="row">
                        <br />
                    </div>    
                    <div className="row">
                            <h3>Bounding Box Image Result</h3>
                    </div>
                    <div className='row'>
                        Waiting for image data...
                    </div>    
                </div>    
            )
        }
        return (
            <div className='container'>
                <div className="row">
                        <h3>Bounding Box Image Result</h3>
                </div>
                <div className='row'>
                    <img src={bb.imgData.dataUrl} />
                </div>    
            </div>    
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        bb: state.bb
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      initBboxDataLoading: () => {
         dispatch(actions.initBboxDataLoading())  
      },
      grabBboxData: (taskId) => {
        dispatch(actions.grabBboxData(taskId))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(BboxImgRes);


// WEBPACK FOOTER //
// ./src/views/BboxImgRes/BboxImgRes.js